var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex flex-col mb-4 desktop:flex-row" }, [
      _c(
        "div",
        { staticClass: "relative -mx-4 px-4 py-2 desktop:py-0" },
        [
          _c(
            "div",
            {
              staticClass:
                "absolute inset-0 opacity-gradient-top desktop:hidden"
            },
            [
              _c("div", { staticClass: "absolute inset-0 bg-gray-300" }),
              _vm.movie.posterUrl
                ? _c("div", {
                    staticClass: "absolute inset-0 opacity-75 bg-cover",
                    style: {
                      filter: "blur(.5px)",
                      backgroundImage: "url('" + _vm.movie.posterUrl + "')"
                    }
                  })
                : _c("BaseIcon", {
                    staticClass:
                      "\n                        absolute inset-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1/3 h-auto\n                        text-gray-500\n                    ",
                    attrs: { name: "photo" }
                  })
            ],
            1
          ),
          _c("MoviePoster", {
            staticClass: "w-24 rounded shadow flex-shrink-0 mr-4 desktop:w-64",
            class: { "opacity-0 desktop:opacity-100": !_vm.movie.posterUrl },
            attrs: { url: _vm.movie.posterUrl }
          })
        ],
        1
      ),
      _c("div", { staticClass: "flex flex-col flex-grow" }, [
        _c(
          "div",
          { staticClass: "flex justify-between" },
          [
            _c("div", { staticClass: "flex flex-col" }, [
              _c(
                "h1",
                {
                  staticClass: "text-2xl font-semibold mb-1 mt-2 desktop:mt-0"
                },
                [
                  _vm._v(" " + _vm._s(_vm.movie.title) + " "),
                  _vm.movie.releaseDate
                    ? _c("span", { staticClass: "font-medium text-lg" }, [
                        _vm._v(
                          " (" +
                            _vm._s(_vm.movie.releaseDate.getFullYear()) +
                            ") "
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _c(
                "div",
                { staticClass: "text-sm mb-3" },
                [
                  !_vm.$viewer.isActive
                    ? _c(
                        _vm.movie.watched ? "div" : "button",
                        _vm._g(
                          _vm._b(
                            {
                              tag: "component",
                              staticClass: "group leading-normal"
                            },
                            "component",
                            _vm.movie.watched ? {} : { type: "button" },
                            false
                          ),
                          _vm.movie.watched ? {} : { click: _vm.markWatched }
                        ),
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex items-center",
                              class: {
                                "text-green-700": _vm.movie.watched,
                                "text-blue-700 group-hover:text-green-700":
                                  _vm.movie.pending
                              }
                            },
                            [
                              _vm.movie.pending
                                ? [
                                    _c("BaseIcon", {
                                      staticClass:
                                        "w-3 h-3 mr-1 group-hover:hidden",
                                      attrs: { name: "time" }
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "group-hover:hidden" },
                                      [_vm._v("watch later")]
                                    )
                                  ]
                                : _vm._e(),
                              _c("BaseIcon", {
                                staticClass: "w-3 h-3 mr-1",
                                class: {
                                  "hidden group-hover:block": _vm.movie.pending
                                },
                                attrs: { name: "checkmark" }
                              }),
                              _c(
                                "span",
                                {
                                  class: {
                                    "hidden group-hover:block":
                                      _vm.movie.pending
                                  }
                                },
                                [_vm._v("watched")]
                              )
                            ],
                            2
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            !_vm.$viewer.isActive
              ? _c("BaseMenu", {
                  attrs: {
                    direction: "top-right",
                    options: [
                      _vm.movie && _vm.movie.watched
                        ? {
                            text: "Watch later",
                            icon: "time",
                            handle: _vm.markWatchLater
                          }
                        : {
                            text: "Watch",
                            icon: "checkmark",
                            handle: _vm.markWatched
                          },
                      { text: "Delete", icon: "trash", handle: _vm.deleteMovie }
                    ]
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var toggleActionsMenu = ref.toggle
                          return [
                            _c("BaseButton", {
                              staticClass:
                                "w-8 h-8 -mr-2 mt-2 justify-center desktop:mt-0 hover:bg-black-overlay",
                              attrs: {
                                icon: "more",
                                "aria-label": "Open actions menu",
                                "no-padding": ""
                              },
                              on: { click: toggleActionsMenu }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4138837446
                  )
                })
              : _vm._e()
          ],
          1
        ),
        _c("p", { staticClass: "leading-relaxed text-gray-700" }, [
          _vm._v(" " + _vm._s(_vm.movie.description || "No description.") + " ")
        ]),
        _vm.externalModels
          ? _c(
              "ul",
              { staticClass: "flex items-center justify-end mt-4" },
              _vm._l(_vm.externalModels, function(externalModel) {
                return _c(
                  "li",
                  { key: externalModel.domain, staticClass: "mr-2" },
                  [
                    _c(
                      "a",
                      { attrs: { href: externalModel.url, target: "_blank" } },
                      [
                        externalModel.icon
                          ? _c("BaseIcon", {
                              staticClass: "w-auto h-5",
                              attrs: { name: externalModel.icon }
                            })
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "text-sm text-primary-700 hover:underline hover:text-primary-900"
                              },
                              [
                                _vm._v(
                                  " view at " +
                                    _vm._s(externalModel.domain) +
                                    " "
                                )
                              ]
                            )
                      ],
                      1
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }